import React from 'react';

import Filters from '../../GenericComponents/Filters/Filters';
import Footer from '../../GenericComponents/Footer/Footer';
import { HawkWidgetContext } from '../../GenericComponents/HawkWidget/HawkWidgetContext';
import { SeasonalEventCountdown } from '../../GenericComponents/Seasonal/SeasonalEventCountdown';
import { SeasonalEventMerchants } from '../../GenericComponents/Seasonal/SeasonalEventMerchants';

import { getWidgetTitle } from './getWidgetTitle';
import ReviewRetailItems from './ReviewRetailItems';

const ReviewRetail: React.FC = () => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element => {
      const {
        loading,
        seasonal,
        data,
        showReviewsPosition,
        widgetTitle,
        translate,
        models,
        name,
        genericSharedComponents: {
          HawkTabs,
          LoadMore,
          ModelCodeReviews,
          Spinner,
          Title,
          LazyImage,
        },
        site,
      } = value;

      return (
        <>
          {loading && <Spinner site={site} LazyImage={LazyImage} />}
          <Title
            {...{
              title: getWidgetTitle({
                widgetTitle,
                name,
                translate,
                data,
                models: models as Record<string, number>,
              }),
            }}
          />
          {['default', 'top'].includes(showReviewsPosition) && (
            <ModelCodeReviews
              {...{
                className: 'review-widget',
              }}
            />
          )}
          {seasonal === 'event' && <SeasonalEventCountdown />}
          <Filters />
          <HawkTabs />
          <ReviewRetailItems />
          {showReviewsPosition === 'bottom' && (
            <ModelCodeReviews
              {...{
                className: 'review-widget-bottom',
              }}
            />
          )}
          {seasonal === 'event' && <SeasonalEventMerchants />}
          {(seasonal !== 'event' || !data.event) && <LoadMore />}
          <Footer
            {...{
              showDescription: true,
              showPoweredBy: true,
            }}
          />
        </>
      );
    }}
  </HawkWidgetContext.Consumer>
);

export default ReviewRetail;
